/**
 * Wheel Configurator Colours
 * ------------------------------------------------------------------------------
 * A script to control the colour variants on the wheel configurator.
 *
 * @namespace wheelConfigColours
 */
import log from 'salvo-lite/log'

import {imageParameters, on} from '../../helpers/utils'

class WcColours {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            carImageContainer: '[js-car-image-container]',
            carColourInputs: '[js-colour-input]',
            ...JSON.parse(elem.getAttribute('data-wc-colour') || '{}')
        }

        /**
         * Node selectors.
         */
        this._nodeSelectors = {
            carImageContainer: document.querySelectorAll(this._settings.carImageContainer),
            carColourInputs: document.querySelectorAll(this._settings.carColourInputs)
        }

        /**
         * Global variables.
         */
        this._currentCarImage = null

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise accordion component.
     */
    onInit () {
        this._setListeners()
        this._setChangeEvents()
    }

    /**
     * Listen for events
     * 1. WheelConfig:colourChanged - fired when the selected colour option changes.
     */
    _setListeners () {
        window.Frame.EventBus.listen('WheelConfig:colourChanged', (input) => this._updateCarImage(input))
    }

    /**
     * Set change events
     */
    _setChangeEvents () {
        this._nodeSelectors.carColourInputs.forEach((input) => {
            on('change', input, () => {
                if (!input.checked) {
                    return
                }
                window.Frame.EventBus.emit('WheelConfig:colourChanged', input)
                window.Frame.EventBus.emit('WheelConfig:optionChanged')
            })
        })
    }

    /**
     * Update the car image in the slider with the selected input colour
     * @param {Object} input the checked colour input
     */
    _updateCarImage (input) {
        this._currentCarImage = input.dataset.imageUrl

        this._nodeSelectors.carImageContainer.forEach((car) => {
            car.innerHTML = `
            <img
            class="wheel-config-car__img"
            src="${imageParameters(this._currentCarImage, {size: '320x'})}"
            alt=""
            srcset="
                ${imageParameters(this._currentCarImage, {size: '1080x'})} 1080w,
                ${imageParameters(this._currentCarImage, {size: '900x'})} 900w,
                ${imageParameters(this._currentCarImage, {size: '768x'})} 768w,
                ${imageParameters(this._currentCarImage, {size: '540x', scale: 2})} 540w,
                ${imageParameters(this._currentCarImage, {size: '320x', scale: 2})} 320w"
            sizes="auto"
            >`
        })
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // })
}

export default WcColours



// WEBPACK FOOTER //
// ./src/resources/scripts/components/wheel-config/WcColours.js